module.exports = __webpack_public_path__ + "img/icon-home-3d.8cacea31.png";